import InlineTipError from '@/components/inline-tips/InlineTipError'
import RetryButton from './RetryButton'

type ContentViewerErrorStateProps = {
  message?: string
  onRetry?: () => void
}

/**
 * Content Viewer Error State Component
 *
 * Unified error display component for all content viewer renderers.
 * Provides consistent error messaging and optional retry functionality.
 * Uses centered full-height layout for consistent UX across all content types.
 *
 * @param message - Custom error message (defaults to 'Failed to load content.')
 * @param onRetry - Optional retry callback function
 */
export default function ContentViewerErrorState({ message = 'Failed to load content.', onRetry }: ContentViewerErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full w-full p-4">
      <div className="mb-4">{InlineTipError(message)}</div>
      {onRetry && <RetryButton onClick={onRetry} />}
    </div>
  )
}
